/** Flatten payload.meta into display rows (string values; objects JSON-encoded). */
export function payloadMetaEntries(
  payload: Record<string, unknown> | undefined,
): Array<{ key: string; value: string }> {
  const meta = payload?.meta;
  if (!meta || typeof meta !== 'object' || Array.isArray(meta)) {
    return [];
  }
  return Object.entries(meta as Record<string, unknown>).map(([key, raw]) => {
    let value = '';
    if (raw === null || raw === undefined) {
      value = '';
    } else if (typeof raw === 'string') {
      value = raw;
    } else if (typeof raw === 'number' || typeof raw === 'boolean') {
      value = String(raw);
    } else {
      try {
        value = JSON.stringify(raw);
      } catch {
        value = String(raw);
      }
    }
    return { key, value };
  });
}
